import Lang from './lang';

const enUS: Lang = {
  PAGE_TITLE: 'PPL Widget Administration | API Keys Management',

  // Header
  MENU: 'Menu',
  MENU_LINK1: 'Personal',
  MENU_LINK2: 'Business',
  MENU_LINK3: 'About us',
  MENU_LINK4: 'Track a shipment',
  MENU_LINK5: 'Send a parcel',
  MENU_LINK6: 'Career',
  MENU_LINK7: 'Customer zone',

  // Footer
  FOOTER_NAME1: 'PPL',
  FOOTER_LINK11: 'About us',
  FOOTER_LINK12: 'Pickup points map',
  FOOTER_LINK13: 'Pickup points list',
  FOOTER_LINK14: 'Transport network',
  FOOTER_LINK15: 'Current information',
  FOOTER_LINK16: 'For Media',
  FOOTER_LINK17: 'Privacy Policy',
  FOOTER_LINK18: 'Career',
  FOOTER_LINK19: 'Whistleblowing',
  FOOTER_NAME2: 'Personal',
  FOOTER_LINK21: 'Track a shipment',
  FOOTER_LINK22: 'Pick-up points',
  FOOTER_LINK23: 'Send a parcel',
  FOOTER_LINK24: 'Returning goods',
  FOOTER_LINK25: 'Damaged shipment',
  FOOTER_LINK26: 'Customer service',
  FOOTER_LINK27: 'Mobile app',
  FOOTER_LINK28: 'Documents to download',
  FOOTER_NAME3: 'Business',
  FOOTER_LINK31: 'Become a customer',
  FOOTER_LINK32: 'Send a parcel',
  FOOTER_LINK33: 'Domestic transport',
  FOOTER_LINK34: 'International transport',
  FOOTER_LINK35: 'Application Client',
  FOOTER_LINK36: 'Customer zone',
  FOOTER_LINK37: 'Integrators',
  FOOTER_LINK38: 'Documents to download',
  FOOTER_NAME4: 'Useful Links',
  FOOTER_LINK41: 'Consent settings',
  FOOTER_LINK42: 'Customer service',
  FOOTER_LINK43: 'Contact form',
  FOOTER_LINK44: 'Damaged shipment',
  FOOTER_LINK45: 'Parcelshops',
  FOOTER_LINK46: 'I want a Parcelbox',
  FOOTER_LINK47: 'I want a Parcelshop',
  FOOTER_LINK48: 'I operate a Parcelshop',
  FOOTER_LINK49: 'Dispute resolution',
  FOOTER_LINK4X: 'Terms and Conditions',
  FOOTER_NAME5: 'Follow Us',
  FOOTER_NAME6: 'MOJEPPL Mobile App',
  FOOTER_NAME7: 'Your parcels are our world',

  // Landing page
  LANDING_SUBTITLE:
    'Set up the pickup point widget and easily embed it on your website, or modify the settings of an already deployed solution.',
  API_ENDPOINT_LABEL: 'API Endpoint:',
  CREATE_API_KEY: 'Get access',
  EDIT_API_KEY: 'Edit settings',

  // CreateApiKeyForm
  CREATE_API_KEY_TITLE: 'Widget configuration access setup',
  CREATE_API_KEY_SUBTITLE:
    'Enter your customer details. We will send the configuration access to your e-mail.',
  ORG_ID_LABEL: 'Org ID',
  ORG_ID_PLACEHOLDER: 'Enter Organization ID',
  CUSTOMER_ID_LABEL: 'Cust ID/Contact e-mail',
  CUSTOMER_ID_PLACEHOLDER: 'Enter Custtomer ID or e-mail',
  EMAIL_LABEL: 'E-mail',
  EMAIL_PLACEHOLDER: 'your.email@example.com',
  EMAIL_TOOLTIP:
    'The contact e-mail must match the e-mail stated in the contract.',
  CUSTOMER_ID_TOOLTIP: 'You can find your Customer ID in your client zone.',
  SUBMIT: 'Generate API Key',
  SUBMITTING: 'Submitting...',
  CANCEL: 'Cancel',
  CLOSE: 'Close',
  SUCCESS_REQUEST_SENT: 'Done! Access is on the way',
  SUCCESS_API_KEY_SENT:
    'We have sent you the widget configuration link by e-mail.',
  RESEND_EMAIL: 'Resend e-mail',
  ERR_ORG_ID_REQUIRED: 'Please enter Organization ID',
  ERR_EMAIL_REQUIRED: 'Please enter e-mail',
  ERR_ORG_ID_INVALID:
    'Organization ID must contain only numbers (max 20 characters)',
  ERR_CUSTOMER_ID_INVALID: 'Customer ID must be a positive number',
  ERR_EMAIL_INVALID: 'Please enter a valid e-mail address',
  ERR_CUST_ID_OR_EMAIL_REQUIRED: 'Please enter Customer ID or contact email',
  ERR_CUST_ID_OR_EMAIL_INVALID:
    'Enter a valid customer number or e-mail address',
  ERR_RECAPTCHA: 'reCAPTCHA verification failed. Please try again.',
  ERR_ORG_CUSTOMER_MISMATCH:
    'Customer ID is invalid. Please contact Customer Service.',
  ERR_ORG_EMAIL_MISMATCH:
    'Your e-mail was not found, please enter your ID or contact customer service.',
  ERR_REQUEST_FAILED: 'Failed to send request. Please try again.',

  // EditApiKeyForm
  APP_TITLE: 'PPL Widget Administration',
  EDIT_API_KEY_TITLE: 'Edit API Key settings',
  EDIT_API_KEY_DESC:
    'Enter the e-mail associated with your API keys. We will send you a link to manage your settings.',
  SEND_LINK: 'Edit settings',
  SENDING: 'Sending...',
  LINK_SENT_TITLE: 'Link sent!',
  LINK_SENT_DESC: 'We have sent an e-mail with a management link to {email}.',
  LINK_VALIDITY: 'The link is valid for 60 minutes.',

  // ActivatePage
  ACTIVATING: 'Activating your link...',
  ACTIVATION_COMPLETE: 'Activation complete',
  ACTIVATION_ERROR: 'Activation error',
  YOUR_API_KEYS: 'Your API Keys',
  API_KEY_DETAIL: 'API Key Detail',
  API_KEY_ACTIVATED: 'API key was successfully activated!',
  GO_TO_SETTINGS: 'Go to settings',
  CAN_CONFIGURE_DOMAINS:
    'You can now go to settings and configure allowed domains.',
  NO_API_KEYS: 'No API keys found for this e-mail.',
  CUSTOMER_ID: 'Customer ID:',
  API_KEY: 'API Key',
  COPY_API_KEY: 'Copy API Key',
  CREATED: 'Created:',
  LOGOUT: 'Log out',
  SESSION_EXPIRES_IN_TOOLTIP: 'Remaining session time',
  SESSION_EXPIRED: 'Your session has expired. Please sign in again.',
  BACK_TO_LIST: 'Back to list',
  LIST_APIKEY: 'Configuration list',
  SAVE_CHANGES: 'Save changes',
  SAVING: 'Saving...',
  CHANGES_SAVED:
    'Changes were saved successfully and the widget has been activated. Your changes will be reflected in a few minutes.',
  BACK: 'Back',

  // ActivatePage - errors
  ERR_TOKEN_ALREADY_USED:
    'This activation link has already been used. Please request a new one.',
  ERR_TOKEN_EXPIRED:
    'The activation link has expired. Please request a new one.',
  ERR_INVALID_LINK: 'Invalid activation link.',
  ERR_SESSION_EXPIRED:
    'Your session has expired. Please request a new activation link.',
  SESSION_EXPIRED_TITLE: 'Your session has expired',
  SESSION_EXPIRED_DESC:
    "Haven't finished? We'll send a new access link to your email.",
  SESSION_EXPIRED_BUTTON: 'Send access',
  ERR_LOAD_API_KEY: 'Failed to load API key details.',
  ERR_SAVE_FAILED: 'Failed to save changes. Please try again.',
  ERR_SELECT_COUNTRY: 'You must select at least one country.',
  ERR_SELECT_AP_TYPE: 'You must select at least one dispensing location type.',
  ERR_DOMAINS_EMPTY: 'All domains must have a value.',
  ERR_REQUIRED_FIELD: 'Required field',
  ERR_DOMAIN_INVALID: 'Invalid domain format (e.g. example.com)',
  SESSION_TIMEOUT_WARNING:
    'Configuration must be completed within 60 minutes. After that, it will be interrupted.',

  // ActivatePage - claims editor
  ALLOWED_DOMAINS: 'Allowed Domains',
  ADD_DOMAIN: 'Add domain',
  NO_DOMAIN_RESTRICTION:
    'No domain restrictions. Widget will work on all domains.',
  DOMAIN_PLACEHOLDER: 'e.g. example.com',
  REMOVE_DOMAIN: 'Remove domain',
  ACCESS_POINT_TYPES: 'Access Point Types',
  DEFAULT_LANGUAGE: 'Default Language',
  LANG_CS: 'Czech',
  LANG_EN: 'English',
  LANG_PL: 'Polish',
  COUNTRIES: 'Countries',
  COUNTRIES_HINT: '(at least one)',

  // Widget Wizard
  WIDGET_SETTINGS: 'Widget Settings',
  HELP_TEXT: 'Need help? Check out the',
  HELP_TEXT_MOBILE: 'Find help in the',
  HELP_LINK_TEXT: 'manual',
  ADD_DOMAIN_LABEL: 'Add domain',
  ADD_NEXT: 'add another',
  PRODUCT_TYPE: 'Product Type',
  PRODUCT_CUSTOM: 'Custom settings',
  PRODUCT_SMART2BOX: 'Smart 2 Box',
  PRODUCT_SMART2BOX_TOOLTIP:
    'This setting automatically preselects the "PPL Parcelbox" access point type and restricts the selection to the Czech Republic only.',
  ACCESS_POINT_TYPES_LABEL: 'Access Point Types',
  AP_PARCELSHOP: 'ParcelShop - PPL Pickup Points',
  AP_PPLPARCELBOX: 'PPL ParcelBox - Self-service PPL boxes',
  AP_ALZABOX: 'AlzaBox - Self-service Alza boxes',
  AVAILABLE_COUNTRIES: 'Available Countries',
  SELECT_ALL: 'Select all',
  SELECTED_COUNT: 'Selected',
  DEFAULT_WIDGET_COUNTRY: 'Default Widget Country',
  RESET: 'Reset',
  PUBLISH: 'Activate',
  WIDGET_CODE: 'Widget Code',
  COPY_CODE: 'Copy',
  CODE_COPIED: 'Code has been copied to clipboard.',
  API_KEY_COPIED: 'API key has been copied to clipboard.',
  WIDGET_CODE_COMMENT_SCRIPT:
    'Place this script in the <head> section of your page',
  WIDGET_CODE_COMMENT_ELEMENT:
    'Place this element where you want to display the widget',
  WIDGET_CODE_COMMENT_BUTTON_ONCLICK: 'Option 1: Open the widget using onclick',
  WIDGET_CODE_COMMENT_BUTTON_EVENT:
    'Option 2: Open the widget using an event listener',
  WIDGET_CODE_BUTTON_TEXT: 'Select pickup point',
  PREVIEW: 'Preview',
  WIDGET_CODE_TAB_TOOLTIP:
    'First confirm the selected configuration settings, then activate it with the Activate button.',
  VIEW_MODE_LABEL: 'Display Type',
  VIEW_MODE_INLINE: 'Embedded in page (Inline)',
  VIEW_MODE_MODAL: 'Pop-up Window (Modal)',
  ACTIVATION_SNACKBAR:
    'If you are implementing the code for the first time, copy it and paste it into your integration. For subsequent changes, just click \u2018Activate\u2019 \u2013 the changes will be applied automatically.',

  // API Key List
  SELECT_CONFIG_TITLE: 'Select configuration to edit',
  SELECT_CONFIG_DESC: 'Choose the API key/domain you want to edit.',
  DOMAINS_LABEL: 'Domains',
  EDIT_BUTTON: 'Edit',
  KEY_ACTIVE: 'Active',
  KEY_INACTIVE: 'Inactive',

  // Unsaved changes dialog
  UNSAVED_CHANGES_TITLE: 'You have unsaved changes',
  UNSAVED_CHANGES_DESC: 'Do you want to save changes before leaving?',
  DISCARD: 'Discard',
};

export default enUS;
